export enum ELASTIC_SEARCH_SORT_ORDER {
  ASC = 'Asc',
  DESC = 'Desc',
  NONE = ''
}